<template>
<section class="aml">
    <md-button class="aml-icon" :class="{'aml-active': isShowed}" @click="toggleShow">
        <span class="text_small" :style="{'color': `${numColor}`}">Risk score: <span class="aml-number" :style="{'color': `${numColor}`}">{{ riskScore }}</span></span>
        <md-icon class="arrow-down-icon-aml  md-icon-size-065x">
            <svg height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" /></svg>
        </md-icon>
    </md-button>
    <div class="aml-container" v-show="isShowed">
        <div class="aml-col" v-for="risk, index in risks" :key="`aml-${index}`">
            <div class="aml-row" v-for="innerRisk, index in risk" :key="`innder-${index}`">
                <div class="aml-row-inner" :class="{'opacityed': +innerRisk[1] === 0.0}">
                    <p class="text_small" :class="{'hight': higthRisk.includes(innerRisk[0])}">{{ innerRisk[0] | replaceUnderscore }}</p>
                    <p class="text_small" :class="{'hight': higthRisk.includes(innerRisk[0])}">{{ innerRisk[1] }}</p>
                </div>
            </div>
        </div>
        <div class="aml-col">
            <AmlIndicatore :value="riskScore" :higth="isHigthRiskscore"/>
        </div>
    </div>
</section>
</template>

<script>
  import AmlIndicatore from './AmlIndicatore.vue'

  export default {
    name: 'Aml',
    components: {AmlIndicatore},
    props: {
      values: {
        required: true,
        type: Object
      },
      score: {
        required: true,
        type: String
      },
      higthRisk: {
        default: []
      }
    },
    data () {
      return {
        isShowed: false
      }
    },
    methods: {
      toggleShow () {
        this.isShowed = !this.isShowed
      }
    },
    computed: {
      numColor () {
        const val = +this.score
        if (this.isHigthRiskscore) {
          return 'red'
        }
        if (val <= 30) {
          return 'black'
        } else if (val > 30 && val <= 60) {
          return 'black'
        } else if (val > 60) {
          return 'red'
        }
      },
      riskScore () {
        return Number(this.score).toFixed(1)
      },
      isHigthRiskscore () {
        return this.higthRisk.includes('riskscore')
      },
      risks () {
        const newObj = {}
        for (const key in this.values) {
          newObj[key] = Number(this.values[key]) * 100
          newObj[key] = newObj[key].toFixed(1)
        }
        const dataArray = Object.entries(newObj)
        const itemsPerInnerArray = 5
        const resultArray = []
        for (let i = 0; i < dataArray.length; i += itemsPerInnerArray) {
          const innerArray = dataArray.slice(i, i + itemsPerInnerArray)
          resultArray.push(innerArray)
        }
        return resultArray
      }
    },
    filters: {
      replaceUnderscore (value) {
        if (!value) return ''
        value = value.replace(/_/g, ' ')
        let parts = value.split(' ')
        parts = parts.map(part => {
          if (part.length <= 3) {
            return part.toUpperCase()
          }
          return part
        })
        let result = parts.join(' ')
        if (!/^[A-Z]+$/.test(result.replace(/ /g, ''))) {
          result = result.charAt(0).toUpperCase() + result.slice(1)
        }
        return result
      }
    }
  }
</script>

<style scoped lang="scss">
.aml-container {
    display: flex;
    gap: 25px;
    flex-wrap: wrap;
}
.aml-icon {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .arrow-down-icon-aml {
        transition: all 0.4s ease-in-out;
    }
}
.aml-active {
    .arrow-down-icon-aml {
        transform: rotate(180deg);
    }
}
.aml-container {
    .aml-row {
        width: 222px;
    }
    .aml-row-inner {
        display: flex;
        gap: 15px;
    }
    .opacityed {
        opacity: 0.7;
    }
    .aml-col {
        margin-top: 15px;
    }
}
.hight {
  font-weight: bold;
  color: red;
  opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/vue/app/history/index/components/Aml.vue